import PATHS, { mergePaths } from 'utils/paths';

export const routeMapping = {
	// Company admin pending orders
	assignedToWarehouse: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	shipmentCanceled: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	branchAssigned: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	pending: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	new: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	pickupFromStore: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	addressConfirmed: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	latlonProcessStarted: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	waitingAddressConfirmation: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	waitingAssignment: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	interDepotTransfer: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	needConfirmation: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	paymentTypeConfirmed: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	codOrderConfirmed: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	missingData: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	confirmationFailed: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS),
	// Company admin awaiting pickup
	awaitingPickup: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	searchingDriver: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	goingToPickup: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	arrivedPickup: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	shipmentCreated: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	readyForCollection: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	returnShipmentProcessing: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	reverseShipmentCreated: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	reverseGoingToPickup: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	reverseShipmentProcessing: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	driverAssigned: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	pickupAttempted: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP),
	// Company admin shipment in progress
	currentlyShipping: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	outForDelivery: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	arrivedDestinationTerminal: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	arrivedOriginTerminal: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	arrivedTerminal: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	reverseDepartedTerminal: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	pickedUp: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	arrivedDestination: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	shipmentInProgress: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	inTransit: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	departedTerminal: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	reverseArrivedTerminal: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	returnProcessing: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	undeliveredAttempt: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	reverseOutForDelivery: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	reversePickedUp: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	reverseUndeliveredAttempt: mergePaths(PATHS.SHIPMENTS, PATHS.CURRENTLY_SHIPPING),
	// Company admin onhold orders
	shipmentOnHold: mergePaths(PATHS.SHIPMENTS, PATHS.ONHOLD_ORDERS),
	shipmentOnHoldToCancel: mergePaths(PATHS.SHIPMENTS, PATHS.ONHOLD_ORDERS),
	shipmentOnHoldWarehouse: mergePaths(PATHS.SHIPMENTS, PATHS.ONHOLD_ORDERS),
	// Company admin delivered orders
	delivered: mergePaths(PATHS.SHIPMENTS, PATHS.DELIVERED_ORDERS),
	reverseShipmentCanceled: mergePaths(PATHS.SHIPMENTS, PATHS.DELIVERED_ORDERS),
	partiallyDelivered: mergePaths(PATHS.SHIPMENTS, PATHS.DELIVERED_ORDERS),
	// Company admin returned orders
	returned: mergePaths(PATHS.SHIPMENTS, PATHS.RETURNED_ORDERS),
	reverseReturned: mergePaths(PATHS.SHIPMENTS, PATHS.RETURNED_ORDERS),
	reverseConfirmReturn: mergePaths(PATHS.SHIPMENTS, PATHS.RETURNED_ORDERS),
	confirmedReturn: mergePaths(PATHS.SHIPMENTS, PATHS.RETURNED_ORDERS),
	// Company admin canceled orders
	canceled: mergePaths(PATHS.SHIPMENTS, PATHS.CANCELED_ORDERS),
	lostOrDamaged: mergePaths(PATHS.SHIPMENTS, PATHS.CANCELED_ORDERS),
	lost: mergePaths(PATHS.SHIPMENTS, PATHS.CANCELED_ORDERS),
	wrongDelivery: mergePaths(PATHS.SHIPMENTS, PATHS.CANCELED_ORDERS),
	// Company admin all orders
	allOrders: mergePaths(PATHS.SHIPMENTS, PATHS.ALL_ORDERS)
};

export const routeMappingForBranch = {
	// Branch user pending orders
	pending: PATHS.BR_PENDING_ORDERS,
	pickupFromStore: PATHS.BR_PENDING_ORDERS,
	branchAssigned: PATHS.BR_PENDING_ORDERS,
	shipmentCanceled: PATHS.BR_PENDING_ORDERS,
	readyForCollection: PATHS.BR_PENDING_ORDERS,
	paymentTypeConfirmed: PATHS.BR_PENDING_ORDERS,
	codOrderConfirmed: PATHS.BR_PENDING_ORDERS,
	// Branch user awaiting pickup
	waitingDriver: PATHS.BR_WAITING_FOR_DRIVER,
	searchingDriver: PATHS.BR_WAITING_FOR_DRIVER,
	goingToPickup: PATHS.BR_SHIPMENT_IN_PROGRESS,
	arrivedPickup: PATHS.BR_SHIPMENT_IN_PROGRESS,
	shipmentCreated: PATHS.BR_SHIPMENT_IN_PROGRESS,
	returnShipmentProcessing: PATHS.BR_WAITING_FOR_DRIVER,
	reverseShipmentCreated: PATHS.BR_WAITING_FOR_DRIVER,
	driverAssigned: PATHS.BR_SHIPMENT_IN_PROGRESS,
	pickupAttempted: PATHS.BR_SHIPMENT_IN_PROGRESS,
	// Branch user shipment in progress

	outForDelivery: PATHS.BR_SHIPMENT_IN_PROGRESS,
	arrivedDestinationTerminal: PATHS.BR_SHIPMENT_IN_PROGRESS,
	arrivedOriginTerminal: PATHS.BR_SHIPMENT_IN_PROGRESS,
	arrivedTerminal: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reverseArrivedTerminal: PATHS.BR_SHIPMENT_IN_PROGRESS,
	pickedUp: PATHS.BR_SHIPMENT_IN_PROGRESS,
	inTransit: PATHS.BR_SHIPMENT_IN_PROGRESS,
	departedTerminal: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reverseDepartedTerminal: PATHS.BR_SHIPMENT_IN_PROGRESS,
	returnProcessing: PATHS.BR_SHIPMENT_IN_PROGRESS,
	undeliveredAttempt: PATHS.BR_SHIPMENT_IN_PROGRESS,
	shipmentOnHold: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reverseOutForDelivery: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reversePickedUp: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reverseGoingToPickup: PATHS.BR_SHIPMENT_IN_PROGRESS,
	shipmentInProgress: PATHS.BR_SHIPMENT_IN_PROGRESS,
	arrivedDestination: PATHS.BR_SHIPMENT_IN_PROGRESS,
	shipmentOnHoldToCancel: PATHS.BR_SHIPMENT_IN_PROGRESS,
	shipmentOnHoldWarehouse: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reverseShipmentProcessing: PATHS.BR_SHIPMENT_IN_PROGRESS,
	reverseUndeliveredAttempt: PATHS.BR_SHIPMENT_IN_PROGRESS,
	// Branch user delivered orders
	delivered: PATHS.BR_DELIVERED,
	reverseShipmentCanceled: PATHS.BR_DELIVERED,
	partiallyDelivered: PATHS.BR_DELIVERED,
	// Branch user returned orders
	returned: PATHS.BR_RETURNED,
	confirmedReturn: PATHS.BR_RETURNED,
	reverseReturned: PATHS.BR_RETURNED,
	reverseConfirmReturn: PATHS.BR_RETURNED,
	// Branch user canceled orders
	canceled: PATHS.BR_CANCELED,
	lostOrDamaged: PATHS.BR_CANCELED,
	lost: PATHS.BR_CANCELED,
	wrongDelivery: PATHS.BR_CANCELED,
	// Branch user unassigned orders
	waitingAssignment: PATHS.BR_UNASSINGED
};

export const routeMappingForWarehouse = {
	// Warehouse user pending orders
	pending: PATHS.WH_PENDING_ORDERS,
	assignedToWarehouse: PATHS.WH_PENDING_ORDERS,
	shipmentCanceled: PATHS.WH_PENDING_ORDERS,
	pickupFromStore: PATHS.WH_PENDING_ORDERS,
	readyForCollection: PATHS.WH_PENDING_ORDERS,
	interDepotTransfer: PATHS.WH_PENDING_ORDERS,
	paymentTypeConfirmed: PATHS.WH_PENDING_ORDERS,
	codOrderConfirmed: PATHS.WH_PENDING_ORDERS,
	// Warehouse user awaiting pickup
	awaitingPickup: PATHS.WH_WAITING_PICKUP,
	searchingDriver: PATHS.WH_WAITING_PICKUP,
	goingToPickup: PATHS.WH_WAITING_PICKUP,
	arrivedPickup: PATHS.WH_WAITING_PICKUP,
	shipmentCreated: PATHS.WH_WAITING_PICKUP,
	returnShipmentProcessing: PATHS.WH_WAITING_PICKUP,
	reverseShipmentCreated: PATHS.WH_WAITING_PICKUP,
	pickupAttempted: PATHS.WH_WAITING_PICKUP,
	driverAssigned: PATHS.WH_WAITING_PICKUP,
	// Warehouse user shipment in progress
	pickedUp: PATHS.WH_SHIPMENT_INPROGRESS,
	arrivedOriginTerminal: PATHS.WH_SHIPMENT_INPROGRESS,
	arrivedTerminal: PATHS.WH_SHIPMENT_INPROGRESS,
	reverseArrivedTerminal: PATHS.WH_SHIPMENT_INPROGRESS,
	arrivedDestinationTerminal: PATHS.WH_SHIPMENT_INPROGRESS,
	outForDelivery: PATHS.WH_SHIPMENT_INPROGRESS,
	undeliveredAttempt: PATHS.WH_SHIPMENT_INPROGRESS,
	arrivedDestination: PATHS.WH_SHIPMENT_INPROGRESS,
	inTransit: PATHS.WH_SHIPMENT_INPROGRESS,
	departedTerminal: PATHS.WH_SHIPMENT_INPROGRESS,
	reverseDepartedTerminal: PATHS.WH_SHIPMENT_INPROGRESS,
	shipmentInProgress: PATHS.WH_SHIPMENT_INPROGRESS,
	returnProcessing: PATHS.WH_SHIPMENT_INPROGRESS,
	reverseOutForDelivery: PATHS.WH_SHIPMENT_INPROGRESS,
	reversePickedUp: PATHS.WH_SHIPMENT_INPROGRESS,
	reverseGoingToPickup: PATHS.WH_SHIPMENT_INPROGRESS,
	reverseUndeliveredAttempt: PATHS.WH_SHIPMENT_INPROGRESS,
	reverseShipmentProcessing: PATHS.WH_SHIPMENT_INPROGRESS,

	// Warehouse user onhold orders
	shipmentOnHold: PATHS.WH_SHIPMENT_ONHOLD,
	shipmentOnHoldToCancel: PATHS.WH_SHIPMENT_ONHOLD,
	shipmentOnHoldWarehouse: PATHS.WH_SHIPMENT_ONHOLD,
	// Warehouse user history orders
	delivered: PATHS.WH_HISTORY,
	returned: PATHS.WH_HISTORY,
	confirmedReturn: PATHS.WH_HISTORY,
	canceled: PATHS.WH_HISTORY,
	reverseReturned: PATHS.WH_HISTORY,
	reverseConfirmReturn: PATHS.WH_HISTORY,
	reverseShipmentCanceled: PATHS.WH_HISTORY,
	lostOrDamaged: PATHS.WH_HISTORY,
	lost: PATHS.WH_HISTORY,
	wrongDelivery: PATHS.WH_HISTORY,
	partiallyDelivered: PATHS.WH_HISTORY
};
